/**
* Before and After JS
* -----------------------------------------------------------------------------
*
* All the JS for the Before and After component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    className: 'before-and-after',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.before-and-after__splide' ).length ) {
        $( '.before-and-after__splide' ).each( function( index, element ) {
          const slider = new Splide( $( element )[0], {
            perPage: 1,
            pagination: false,
            arrows: false,
            rewind: true,
            gap: '2rem',
            speed: 800,
          } );

          slider.mount( );

          $( '.next' ).on( 'click', function() {
            slider.go( '+${i}' );
          } );

          $( '.prev' ).on( 'click', function() {
            slider.go( '-${i}' );
          } );

          const thumbnails = $( '.thumbnails' ).each( function( index, thumbnail ) {
            initThumbnail( thumbnail, index );
          } );
          let current;

          function initThumbnail( thumbnail, index ) {
            thumbnail.addEventListener( 'click', function() {
              slider.go( index );
            } );
          }

          slider.on( 'mounted move', function() {
            const thumbnail = thumbnails[slider.index];

            if ( thumbnail ) {
              if ( current ) {
                current.classList.remove( 'is-active' );
              }

              thumbnail.classList.add( 'is-active' );
              current = thumbnail;
            }
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'before-and-after', COMPONENT );
} )( app );
